import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { MasterService } from '../../../Services/master.service';
import { SearchCustomerParam } from '../../../Models/searchCustomer';
import { Utility } from '../../../Utilities/utility';
import { CookieService } from 'ngx-cookie-service';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator, MatPaginatorIntl } from '@angular/material/paginator';




@Component({
  selector: 'app-customer-search',
  templateUrl: './customer-search.component.html',
  styleUrls: ['./customer-search.component.scss']
})

export class CustomerSearchComponent implements OnInit {

  private utility: Utility
  public OfficeList: any[] = [];
  public FormModel: SearchCustomerParam;
  @Output("searchCustomer") searchCustomer: EventEmitter<SearchCustomerParam> = new EventEmitter();
  constructor(private _MasterService: MasterService
    , private cookieService: CookieService
    , private intl: MatPaginatorIntl
    , private changeDectector: ChangeDetectorRef
  ) {
    this.utility = new Utility(this.cookieService);
    this.FormModel = new SearchCustomerParam();
  }

  ngOnInit(): void {
    this._MasterService.GetAllOffices(this.utility.user.officeId == 1 ? 0 : this.utility.user.officeId).subscribe((d) => {
      
      if (this.utility.user.officeId == 1) {
        this.OfficeList.push({ "officeId": "-1", "officeDesc": "-- All Office --" });
      }
      this.OfficeList = this.OfficeList.concat(d);
      this.changeOffice(this.utility.user.officeId);
    },(error) => {                              //Error callback
      this.utility.Error(error);
    });
  }

  changeOffice(officeid?: number) {
    let office: any = this.OfficeList.filter(o =>
      o.officeId == officeid
    )[0];
    this.FormModel.officeId = parseInt(office.officeId);
    this.FormModel.officeDesc = office.officeDesc;
    this.FormModel.UserOfficeId = this.utility.user.officeId;
  }

  formSubmit() {
    this.searchCustomer.emit(this.FormModel);
  }

}

